import { Store } from '@categoryProduct/store/typings';

export default (state: Store) => {
  const section = 'step1';
  const sectionControls = state.controls.sections[section];
  return sectionControls ? sectionControls.numberOfBabies.value : 0;
};
